/**
 *  All api related to department
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchDepartments(options = {}) {
  const params = _.omit(options, ['arrayFormat'])
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchDepartments',
    () => source.cancel('fetchDepartments: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'departments',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: options.arrayFormat,
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      departments: data.departments,
      cacheChecksum: _.get(cacheChecksum, 'departmentsValue'),
    }))
}
